(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // ── Drawer smooth transition — watches Dawn's own open/close via MutationObserver ──
 // ── Drawer smooth transition ──
(function () {
  const DURATION = 280;
  let isAnimating = false;
  let closeTimeout = null;

  function init() {
    const drawerDetails = document.querySelector('header-drawer details');
    const menuDrawer    = document.getElementById('menu-drawer');
    const overlay       = document.getElementById('drawer-overlay');
    const innerContainer = menuDrawer ? menuDrawer.querySelector('.menu-drawer__inner-container') : null;

    if (!drawerDetails || !menuDrawer || !overlay) return;

    // Detect if this is the trope full-width style or the standard slide-in style
    const isTropeLayout = document.querySelector('.trope-home-header') !== null;

    // ── Standard (non-trope) drawer: slide in from left ──
    if (!isTropeLayout) {
      menuDrawer.style.cssText = [
        'position: fixed !important',
        'top: 0 !important',
        'left: 0 !important',
        'width: 100% !important',
        'height: 100vh !important',
        'transform: translateX(-100%)',
        'visibility: hidden',
        'transition: none',
        'z-index: 999',
      ].join(';');
    }

    // Overlay always in DOM
    overlay.style.cssText = [
      // 'display: block',
      // 'position: fixed',
      // 'inset: 0',
      // 'background: rgba(0,0,0,0.25)',
      'z-index: 999',
      // 'opacity: 0',
      // 'pointer-events: none',
      // 'transition: none',
    ].join(';');

    // ── Menu item stagger ──
    function resetMenuItems() {
      const items = menuDrawer.querySelectorAll('.menu-drawer__menu > li');
      items.forEach((item) => {
        item.style.opacity = '0';
        item.style.transform = 'translateY(8px)';
        item.style.transition = 'none';
        item.style.transitionDelay = '0ms';
      });
    }

    function staggerMenuItems() {
      const items = menuDrawer.querySelectorAll('.menu-drawer__menu > li');
      items.forEach((item, i) => {
        const delay = 120 + i * 55;
        setTimeout(() => {
          item.style.transition = `opacity 240ms ease, transform 240ms ease`;
          item.style.opacity    = '1';
          item.style.transform  = 'translateY(0)';
        }, delay);
      });
    }

    function animateOpen() {
      if (isAnimating) return;
      isAnimating = true;
      clearTimeout(closeTimeout);

      document.body.style.overflow = 'hidden';
      resetMenuItems();

      if (isTropeLayout && innerContainer) {
        // ── Trope: fade+slide the inner container ──
        innerContainer.style.transition = 'none';
        innerContainer.style.opacity    = '0';
        innerContainer.style.transform  = 'translateY(-12px)';
        innerContainer.style.pointerEvents = 'none';

        innerContainer.getBoundingClientRect(); // reflow

        innerContainer.style.transition = `opacity ${DURATION}ms cubic-bezier(0.25, 0.46, 0.45, 0.94), transform ${DURATION}ms cubic-bezier(0.25, 0.46, 0.45, 0.94)`;
        innerContainer.style.opacity    = '1';
        innerContainer.style.transform  = 'translateY(0)';
        innerContainer.style.pointerEvents = 'auto';
      } else {
        // ── Standard: slide drawer in from left ──
        menuDrawer.style.transition = 'none';
        menuDrawer.style.transform  = 'translateX(-100%)';
        menuDrawer.style.visibility = 'visible';

        menuDrawer.getBoundingClientRect();

        menuDrawer.style.transition = `transform ${DURATION}ms cubic-bezier(0.25, 0.46, 0.45, 0.94)`;
        menuDrawer.style.transform  = 'translateX(0)';
      }

      // Overlay fade in
      overlay.style.transition    = `opacity ${DURATION}ms ease`;
      overlay.style.opacity       = '0.5';
      overlay.style.pointerEvents = 'auto';

      staggerMenuItems();

      setTimeout(() => { isAnimating = false; }, DURATION + 300);
    }

    function animateClose() {
      if (isAnimating) return;
      isAnimating = true;
      clearTimeout(closeTimeout);

      document.body.style.overflow = '';
      resetMenuItems();

      if (isTropeLayout && innerContainer) {
        innerContainer.style.transition = `opacity ${DURATION}ms cubic-bezier(0.25, 0.46, 0.45, 0.94), transform ${DURATION}ms cubic-bezier(0.25, 0.46, 0.45, 0.94)`;
        innerContainer.style.opacity    = '0';
        innerContainer.style.transform  = 'translateY(-12px)';
        innerContainer.style.pointerEvents = 'none';
      } else {
        menuDrawer.style.transition = `transform ${DURATION}ms cubic-bezier(0.25, 0.46, 0.45, 0.94)`;
        menuDrawer.style.transform  = 'translateX(-100%)';

        closeTimeout = setTimeout(() => {
          menuDrawer.style.visibility = 'hidden';
        }, DURATION);
      }

      overlay.style.transition    = `opacity ${DURATION}ms ease`;
      overlay.style.opacity       = '0';
      overlay.style.pointerEvents = 'none';

      closeTimeout = setTimeout(() => { isAnimating = false; }, DURATION);
    }

    // Watch Dawn's [open] attribute via MutationObserver
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'open') {
          if (drawerDetails.hasAttribute('open')) {
            animateOpen();
          } else {
            animateClose();
          }
        }
      });
    });

    observer.observe(drawerDetails, {
      attributes: true,
      attributeFilter: ['open'],
    });

    // Close on overlay click
    overlay.addEventListener('click', () => {
      drawerDetails.removeAttribute('open');
      drawerDetails.classList.remove('menu-opening');
    });

    // Init overlay
    overlay.style.opacity       = '0';
    overlay.style.pointerEvents = 'none';
    overlay.style.display       = 'block';

    // Init menu items hidden
    resetMenuItems();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
